import { ListUploadFilesResponse } from '@types'

function isPdf(filename: string) {
  return filename.indexOf('pdf') > -1
}

export function legalEntityFilesTransform(
  response: ListUploadFilesResponse
): ListUploadFilesResponse {
  return {
    ...response,
    files: response.files.reverse().map((file) => ({
      ...file,
      type: isPdf(file.filename) ? 'pdf' : 'image',
    })),
  }
}
